import React from 'react';
import {
    Root,
    Row,
    ColSpecial,
    ColActivity,
    ColListings,
    ColDateTime,
    ColViews,
    ColEngagement,
    FormatsAbsoluteContainer,
    FormatsContainer,
    FormatLabel
} from './styles';
import Options from 'components/Options';
import { Special } from 'features/Dealers/Performance/state/types';
import imageListingsUnpublished from 'common/images/listings-unpublished.png';
import imageListingsPublished from 'common/images/listings-published.png';

export interface IState { }

export interface form {
    width: number,
    height: number
}

export interface IProps {
    idx: any;
    item: Special;
}

const ItemSpecial: React.FC<IProps> = ({ item }) => {

    return (
        <Root >
            <Row >
                <ColSpecial> {item.title} </ColSpecial>
                <ColActivity> {item.origin} {item.activity.toLowerCase()+"d"} </ColActivity>
                <ColListings> 
                    { item.activity === 'DELETE' ?
                        <img src={imageListingsUnpublished} width="35" height="31" />
                        :
                        <img src={imageListingsPublished} width="35" height="31" />
                    } 
                    <FormatsAbsoluteContainer>
                        <FormatsContainer>
                            <FormatLabel >
                            { item.activity === 'DELETE' ? `Unpublished` : `Published` }
                            </FormatLabel>
                        </FormatsContainer>
                    </FormatsAbsoluteContainer>
                </ColListings>
                <ColDateTime>
                    {FormatDate(item.activityDateTime)}
                </ColDateTime>
                <ColViews> {item.views == undefined?"-":item.views}</ColViews>
                <ColEngagement>
                    {item.engagement == undefined?"-":item.engagement}
                    {/* <Options
                        name={item.title}
                    /> */}
                </ColEngagement>
            </Row>
        </Root >
    );
}

function FormatDate(date)
{
    return new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(new Date(date))
}
export default ItemSpecial;